import React, { memo } from 'react';

import { IconButton, Popover, Typography } from '@mui/material';
import { CancelIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

const PopoverCDS = ({ children, title = '', ...props }) => {
  return (
    <Popover {...props}>
      <div className="flex flex-col gap-24 p-24">
        <div className="flex items-center justify-between">
          <Typography variant="bold20">{title}</Typography>
          <IconButton disableRipple color="text.dark" onClick={props.onClose}>
            <CancelIcon size={IconSize[20]} />
          </IconButton>
        </div>
        {children}
      </div>
    </Popover>
  );
};

PopoverCDS.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default memo(PopoverCDS);
